/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

export interface IDeviceManufacurer {
  id?: string;
  code?: string | null;
  description?: string | null;
  name?: string | null;
  country?: string | null;
  address?: string | null;
  website?: string | null;
  helpdesk?: string | null;
  gstCode?: string | null;
  regCode?: string | null;
  microSec?: number | null;
  timestampentry?: number | null;
  lastupdated?: number | null;
  cursor?: number;
  active?: boolean | null;
}

export const defaultValue: Readonly<IDeviceManufacurer> = {
  active: false,
};
